// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"01ce5122","455":"6c5083ce","488":"dc6b8870","977":"aba01ae8"}[chunkId] + ".chunk.js";
};